import { ArrowDown, ArrowUp, X } from 'lucide-react'
import { IconButton } from '../common'
import LegRow from './LegRow'
import { legLabel } from './legModel'
import styles from './LegSearch.module.css'

// Selected legs in order. A host that lets the selection change passes
// onRemove, and onMove(leg, -1 | 1) when the order matters.
export default function LegList({ legs, label, oddsFormat = 'american', onRemove, onMove }) {
  return (
    <ul className={styles.legList} aria-label={label}>
      {legs.map((leg, index) => {
        const name = legLabel(leg)
        const actions = onRemove || onMove ? (
          <>
            {onMove ? (
              <>
                <IconButton variant="ghost" label={`Move ${name} up`} disabled={index === 0} onClick={() => onMove(leg, -1)}>
                  <ArrowUp size={16} aria-hidden="true" />
                </IconButton>
                <IconButton variant="ghost" label={`Move ${name} down`} disabled={index === legs.length - 1} onClick={() => onMove(leg, 1)}>
                  <ArrowDown size={16} aria-hidden="true" />
                </IconButton>
              </>
            ) : null}
            {onRemove ? (
              <IconButton variant="ghost" label={`Remove ${name}`} onClick={() => onRemove(leg)}>
                <X size={16} aria-hidden="true" />
              </IconButton>
            ) : null}
          </>
        ) : null
        return (
          <li key={leg.outcome_id} className={styles.legItem}>
            <LegRow compact leg={leg} oddsFormat={oddsFormat} actions={actions} />
          </li>
        )
      })}
    </ul>
  )
}
